import nLogo1 from "assets/images/partnerLogos/1.png"
import nLogo2 from "assets/images/logos/gemeenteleiden.jpeg"
import nLogo3 from "assets/images/partnerLogos/3.png"
import nLogo4 from "assets/images/partnerLogos/4.png"
import nLogo5 from "assets/images/partnerLogos/5.png"
import nLogo6 from "assets/images/logos/maastrichtunilogo.jpeg"
import nLogo7 from "assets/images/partnerLogos/7.png"
import nLogo8 from "assets/images/partnerLogos/8.png"
import nLogo9 from "assets/images/logos/hu.png"
import nLogo10 from "assets/images/partnerLogos/10.png"
import nLogo11 from "assets/images/partnerLogos/11.png"
import nLogo12 from "assets/images/partnerLogos/12.png"
import nLogo13 from "assets/images/partnerLogos/13.png"
import nLogo14 from "assets/images/logos/logoUASLeiden.jpeg"
import nLogo15 from "assets/images/partnerLogos/15.png"
import nLogo16 from "assets/images/partnerLogos/16.png"
import nLogo17 from "assets/images/partnerLogos/17.png"
import nLogo18 from "assets/images/partnerLogos/18.png"
import nLogo19 from "assets/images/partnerLogos/19.jpg"
import nLogo20 from "assets/images/partnerLogos/20.png"

export interface ILogoLink {
  link: string;
  logo: string;
}


export let listPartners2: ILogoLink[] = [
  {
    link: "https://www.utrecht.nl/",
    logo: nLogo1,
  },
  {
    link: "https://gemeente.leiden.nl/inwoners-en-ondernemers/wonen-en-bouwen/wonen/kamer-en-hospitaverhuur/",
    logo: nLogo2,
  },
  {
    link: "https://esn-utrecht.nl/",
    logo: nLogo3,
  },
  {
    link: "https://gemeente.groningen.nl/",
    logo: nLogo4,
  },
  {
    link: "https://www.gemeentemaastricht.nl/",
    logo: nLogo5,
  },
  {
    link: "https://www.maastrichtuniversity.nl/",
    logo: nLogo6,
  },
  {
    link: "https://vu.nl/nl",
    logo: nLogo7,
  },
  {
    link: "https://www.uu.nl/",
    logo: nLogo8,
  },
  {
    link: "https://www.hu.nl/",
    logo: nLogo9,
  },
  {
    link: "https://www.hku.nl/",
    logo: nLogo10,
  },
  {
    link: "https://www.rug.nl/",
    logo: nLogo11,
  },
  {
    link: "https://www.hanze.nl/",
    logo: nLogo12,
  },
  {
    link: "https://www.universiteitleiden.nl/",
    logo: nLogo13,
  },
  {
    link: "https://www.hsleiden.nl/",
    logo: nLogo14,
  },
  {
    link: "https://access-nl.org/",
    logo: nLogo15,
  },
  {
    link: "https://kamersmetaandacht.nl/",
    logo: nLogo16,
  },
  {
    link: "https://vidius.nl/en/",
    logo: nLogo17,
  },
  {
    link: "https://buddygodutch.nl/",
    logo: nLogo18,
  },
  {
    link: "https://www.kluppen.nl/",
    logo: nLogo19,
  },
  {
    link: "https://matchmaastricht.nl/projects/homesharing/",
    logo: nLogo20,
  },

];
